import React, { useEffect, useState, useContext } from "react"
import intl from "react-intl-universal"
import FileIcon from "../../../../../assets/icons/CIQIcon"
import ContentBlank from "../../../../molecules/ContentBlank"
import styles from "./index.module.scss"
import RcmpHeader from "../../../../atoms/Header"
import { listAnalytesCreated } from "../../../../../services/ciq"
import "./style.css"
import { FormEditEquipament } from "../../components/FormEditEquipament"
import { TableLinkAnalytes } from "../../components/TableLinkAnalytes"
import { HistoryComponent } from "../../components/HistoryComponent"
import { listHistory } from "../../../../../services/ciq"
import { useParams } from "react-router-dom"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import AuthContext from "../../../../../contexts/Auth"
import ModalComponent from "../../components/ModalComponent"
import { ModalSettingsEquipment } from "../../components/ModalSettingsEquipment"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"
import { AnalytePicker } from "../../components/AnalytePicker"
import { fnCanAtLeast } from "../../../../../utils/permissions"

const EditEquipaments = () => {
  const [bIsOpenModal, setBisOpenModal] = useState(false)
  const [listAnalytes, setListAnalytes] = useState([])
  const [listAnalytesHistory, setListAnalytesHistory] = useState([])
  const [cSearchText, setSearchText] = useState("")
  const [isChecked, setIsChecked] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [listAnalytesAddInEqp, setListAnalytesAddInEqp] = useState([])
  const [infoInfititeScroll, setInfoInfititeScroll] = useState({})
  const [nPage, setNPage] = useState(1)
  const [per_pageHistory, setPerPageHistory] = useState(1)
  const [search_type, setSearchType] = useState("")
  const [text_type, setTextType] = useState("")
  const [dataHistory, setDataHistory] = useState([])
  const [isChanged, setIsChanged] = useState(false)
  const [analytesVinculatedWithEquipment, setAnalytesVinculatedWithEquipment] = useState(
    [],
  )
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [bIsOpenModalSettingsEquiment, setbIsOpenModalSettingsEquiment] = useState(false)
  const [isTabEdit, setIsTabEdit] = useState(true)

  const [isCheckedSwitch, setIsCheckedSwitch] = useState(false)
  const [abreadCrumbs, setAbreadCrumbs] = useState([])
  const [eqp_analytes, setEqpAnalytes] = useState([])

  const { id } = useParams()

  const [bIsHistoryOpenModal, setBIsHistoryOpenModal] = useState(false)
  const [isLoadHistory, setIsLoadHistory] = useState(false)

  const [tableBodyArray, setTableBodyArray] = useState([])

  const { oUser } = useContext(AuthContext)
  const { dataConfigAnalyte, setDataConfigAnalyte } = useContext(WestgardRulesContext)

  // const [bActiveMaximumInaccuracy, setBActiveMaximumInaccuracy] = useState(false)
  const [isSwitchSuspense, setIsSwitchSuspense] = useState(
    dataConfigAnalyte.anlt_bstatus === true ||
      dataConfigAnalyte.anlt_bstatus === "Ativo" ||
      dataConfigAnalyte.anlt_bstatus === "Active",
  )
  const cUserTimeZone = oUser?.data?.user_ctimezone

  const fnListAnalytes = async (npage, cSearchText) => {
    try {
      if (isLoad) return
      setIsLoad(true)
      if (npage <= 1) setListAnalytes([])

      const response = await listAnalytesCreated(npage, cSearchText, "&anlt_bstatus=1")

      const newData = response.data.data.data
        .map((item) => {
          return {
            anlt_cname: item.anlt_cname,
            anlt_type: item.anlt_type,
            anlt_ruler: "---",
            anlt_imprecision: "---",
            anlt_sector: item.anlt_sector?.sector_cname,
            anlt_nid: item.anlt_nid,
            anlt_bstatus: item.anlt_bstatus
              ? intl.get("ciq.list_analytes.active")
              : intl.get("ciq.list_analytes.inactive"),
            bChecked: false,
          }
        })
        .map((item) => {
          if (item.anlt_type === "Quantitativo") {
            return { ...item, anlt_type: intl.get("ciq.types_analytes.quantitative") }
          } else if (item.anlt_type === "Qualitativo") {
            return { ...item, anlt_type: intl.get("ciq.types_analytes.qualitative") }
          } else {
            return {
              ...item,
              anlt_type: intl.get("ciq.types_analytes.semmi_quantitative"),
            }
          }
        })

      setInfoInfititeScroll({
        last_page: response.data.data.last_page,
      })

      const mergedList = newData.map((item) => {
        const markedItem = listAnalytesHistory.find(
          (mark) => mark.anlt_nid === item.anlt_nid,
        )
        return markedItem ? { ...item, bChecked: markedItem.bChecked } : item
      })

      setListAnalytes((prev) => [...prev, ...mergedList])
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoad(false)
    }
  }

  function debounce(func, delay) {
    let timerId

    return function (...args) {
      clearTimeout(timerId)

      timerId = setTimeout(() => {
        func.apply(this, args)
      }, delay)
    }
  }

  const fnSearchAnalyte = debounce((ev) => {
    const value = ev.target.value.toLowerCase()

    setSearchText(!value ? "" : `&search_text=${value}`)
  }, 500)

  const fnHandleChange = () => {
    const everyPropertiesIsChecked = listAnalytes.every((item) => item.bChecked === true)
    if (!everyPropertiesIsChecked) {
      const newList = listAnalytes.map((item) => {
        return {
          ...item,
          bChecked: true,
        }
      })
      setIsChecked(true)
      setListAnalytes(newList)

      const resultado = listAnalytesHistory.slice()
      newList.forEach((item) => {
        const existeItem = resultado.some((elem) => elem.anlt_cname === item.anlt_cname)
        if (!existeItem) {
          resultado.push(item)
        }
      })

      setListAnalytesHistory(resultado)
    } else {
      setListAnalytes((oldState) =>
        oldState.map((item) => ({ ...item, bChecked: false })),
      )
      setIsChecked(false)

      var listaFiltrada = listAnalytesHistory.filter(function (item1) {
        return !listAnalytes.some(function (item2) {
          return (
            item1.anlt_cname === item2.anlt_cname &&
            item1.anlt_sector === item2.anlt_sector &&
            item1.anlt_type === item2.anlt_type &&
            item1.anlt_bstatus === item2.anlt_bstatus &&
            item1.anlt_nid === item2.anlt_nid &&
            item1.bChecked === item2.bChecked
          )
        })
      })

      setListAnalytesHistory(listaFiltrada)
    }
  }

  const fnHandleSelectAnalyte = (item) => {
    const obj = {
      ...item,
      bChecked: !item.bChecked,
    }

    const newList = listAnalytes.map((it) => {
      if (it.anlt_nid === item.anlt_nid) {
        return obj
      } else {
        return it
      }
    })

    setListAnalytesHistory((oldState) => [...oldState, obj])

    setListAnalytes(newList)

    setIsChanged(true)

    if (listAnalytesHistory.length === 0) {
      return
    } else if (listAnalytesHistory.some((item) => item.anlt_nid === obj.anlt_nid)) {
      setListAnalytesHistory(
        listAnalytesHistory.filter((item) => item.anlt_nid !== obj.anlt_nid),
      )
    }
  }

  function fnNextPage(page) {
    setNPage(page)
  }

  function removeElementsDuplicated(lista1, lista2) {
    const idsToRemove = lista1.map(item => item?.anlt_nid) || [];
    return [...new Set(lista2)].filter(item => !idsToRemove?.includes(item?.anlt_nid));
  }

  let listRemovedDuplicated = removeElementsDuplicated(
    analytesVinculatedWithEquipment,
    listAnalytes,
  )

  const getHistoricEquipment = async (id, perPage, searchType, textType) => {
    try {
      setDataHistory([])
      setIsLoadHistory(true)
      const { data: dt } = await listHistory(
        id,
        perPage,
        searchType,
        textType,
        "equipment",
      )

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  useEffect(() => {
    if (!id || !cUserTimeZone) return

    getHistoricEquipment(id, per_pageHistory, search_type, text_type)
  }, [id, per_pageHistory, search_type, text_type, cUserTimeZone])

  useEffect(() => {
    setNPage(1)
    fnListAnalytes(1, cSearchText)
  }, [cSearchText])

  useEffect(() => {
    if (nPage <= 1) return
    fnListAnalytes(nPage, cSearchText)
  }, [nPage])

  const everyPropertiesIsChecked = listAnalytes.every((item) => item.bChecked === true)

  useEffect(() => {
    if (everyPropertiesIsChecked) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  }, [listAnalytes])

  useEffect(() => {
    if (!bIsOpenModal) {
      const newList = listAnalytes.map((item) => {
        return {
          ...item,
          bChecked: false,
        }
      })

      setListAnalytes(newList)
      setListAnalytesHistory([])
    }
  }, [bIsOpenModal])

  useEffect(() => {
    if (listAnalytesAddInEqp.length > 0) {
      setIsChanged(true)
    }
  }, [listAnalytesAddInEqp])

  useEffect(() => {
    setTableBodyArray(analytesVinculatedWithEquipment.concat(listAnalytesAddInEqp))
  }, [listAnalytesAddInEqp, analytesVinculatedWithEquipment])

  useEffect(() => {
    setEqpAnalytes(
      listAnalytesAddInEqp
        .concat(analytesVinculatedWithEquipment)
        .map((item, index) => {
          return {
            eqpanlt_anlt_nid: item?.anlt_nid,
            eqpanlt_bstatus: item?.anlt_bstatus,
          }
        })
        .map((item) =>
          item.eqpanlt_anlt_nid === dataConfigAnalyte.anlt_nid
            ? { ...item, eqpanlt_bstatus: isCheckedSwitch }
            : item,
        ),
    )
  }, [tableBodyArray])

  const removeDuplicated = removeElementsDuplicated(tableBodyArray, listRemovedDuplicated)

  const list2 = eqp_analytes.map((item) =>
    item.eqpanlt_anlt_nid === dataConfigAnalyte.anlt_nid
      ? {
          ...item,
          eqpanlt_bstatus:
            item.eqpanlt_bstatus === true ||
            item.eqpanlt_bstatus === "Active" ||
            item.eqpanlt_bstatus === "Ativo",
        }
      : item,
  )

  tableBodyArray.forEach((item1, index) => {
    const matchingItem2 = list2.find(
      (item2) => item2.eqpanlt_anlt_nid === item1?.anlt_nid,
    )
    item1.eqpanlt_norder = index
    if (matchingItem2) {
      item1.anlt_bstatus =
        matchingItem2.eqpanlt_bstatus === true ||
        matchingItem2.eqpanlt_bstatus === "Ativo" ||
        matchingItem2.eqpanlt_bstatus === "Active"
          ? intl.get("ciq.list_analytes.active")
          : intl.get("ciq.list_analytes.inactive")
    }
  })

  useEffect(() => {
    if (!fnCanAtLeast("access-ciq", "internal-quality-control")) {
      window.location.href = "/"
      return
    } else if (
      !fnCanAtLeast("create-edit-equipment", "internal-quality-control") &&
      (fnCanAtLeast("create-edit-control", "internal-quality-control") ||
        fnCanAtLeast("create-edit-launch", "internal-quality-control") ||
        fnCanAtLeast("update-run", "internal-quality-control"))
    ) {
      window.location.href = "/"
      return
    }
    setAbreadCrumbs([
      {
        path: "./",
        name: intl.get("home"),
      },
      {
        path: "/ciq",
        name: intl.get("ciq.title"),
      },
      {
        path: "/ciq/list-equipments",
        name: intl.get("ciq.equipment") + "s",
      },
      {
        name: intl.get("ciq.edit_equipment") + "s",
        bActive: true,
      },
    ])
  }, [])

  useEffect(() => {
    const bAdmin = fnCanAtLeast("admin", "internal-quality-control")

    if (bAdmin || fnCanAtLeast("create-edit-equipment", "internal-quality-control")) {
      return
    } else if (!fnCanAtLeast("access-ciq", "internal-quality-control")) {
      window.location.href = "/"
      return
    } else if (
      fnCanAtLeast("create-edit-control", "internal-quality-control") ||
      fnCanAtLeast("create-edit-launch", "internal-quality-control") ||
      fnCanAtLeast("update-run", "internal-quality-control")
    ) {
      window.location.href = "/"
      return
    }
  }, [])

  const fnHandleRemoveVinculatedAnalyte = (oAnalyte) => {
    if (oAnalyte?.eqpanlt_nid) {
       // analyte already vinculated with equipment
      setAnalytesVinculatedWithEquipment(
        analytesVinculatedWithEquipment.filter(
          (item) => item.eqpanlt_nid !== oAnalyte?.eqpanlt_nid,
        ),
      )
    } else {
      setListAnalytesAddInEqp(
        listAnalytesAddInEqp.filter((item) => item?.anlt_nid !== oAnalyte?.anlt_nid),
      )
    }
  }

  const fnHandleOpenAnalyteSettings = (oAnalayte) => {
    let oAnalayteFormated = oAnalayte

    if (!oAnalayteFormated?.eqpanlt) {
      oAnalayteFormated = tableBodyArray?.find(
        (i) => i?.anlt_nid === oAnalayte?.eqpanlt_anlt_nid,
      )
    }

    if (oAnalayteFormated.eqpanlt) {
      setTimeout(() => {
        setbIsOpenModalSettingsEquiment(true)
      }, 100)

      setDataConfigAnalyte(oAnalayteFormated)
      setIsSwitchSuspense(
        oAnalayteFormated.status === true ||
          oAnalayteFormated.status === "Ativo" ||
          oAnalayteFormated.status === "Active" ||
          oAnalayteFormated.status === 1,
      )
    }
  }

  return (
    <div>
      <RcmpHeader
        elIcon={<FileIcon />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={abreadCrumbs}
        className={styles.header}
      ></RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bVisibleIconSearch={false}
        bArrowLeftGoBack={true}
        cPathGoBack={"/ciq/list-equipments"}
        cLabelGoBack={intl.get("ciq.edit_equipment") + "s"}
        className={styles.contentB1lankCustom}
        bShowHistory
        fnHandleOpenModal={() => setBIsHistoryOpenModal(true)}
      >
        <FormEditEquipament
          setBisOpenModal={setBisOpenModal}
          setIsChanged={setIsChanged}
          isChanged={isChanged}
          equipment_analytes={tableBodyArray.map((item) => ({
            eqpanlt_nid: item?.eqpanlt_nid,
            eqpanlt_anlt_nid: item.anlt_nid,
            eqpanlt_bstatus: item.status,
            eqpanlt_nimprecision_value: item.eqpanlt_nimprecision_value,
            eqpanlt_cjustification: item.eqpanlt_cjustification,
            eqpanlt_norder: item.eqpanlt_norder,
            eqpanlt_bmax_imprecision: item.eqpanlt_bmax_imprecision,
            eqpanlt_bsigma: item.eqpanlt_bsigma,
            eqpanlt_eimprecision_type:
              item.eqpanlt_eimprecision_type === null
                ? "MANUAL"
                : item.eqpanlt_eimprecision_type,
            awestgard_rules:
              item.eqpanlt_westgard?.map((item) => ({
                eqpanltwgr_wgrdr_nid: item.eqpanltwgr_wgrdr_nid,
                eqpanltwgr_eaction: item.eqpanltwgr_eaction,
                eqpanltwgr_bstatus: item.eqpanltwgr_bstatus,
              })) || [],
            eqpanlt_cintegration_code: item?.eqpanlt_cintegration_code,
          }))}
          setAnalytesVinculatedWithEquipment={setAnalytesVinculatedWithEquipment}
          fnHandleOpenAnalyteSettings={fnHandleOpenAnalyteSettings}
        >
          <TableLinkAnalytes
            bControl={false}
            setIsChanged={setIsChanged}
            thead={[
              intl.get("ciq.header_table_link_analytes.name"),
              intl.get("ciq.header_table_link_analytes.type"),
              intl.get("ciq.header_table_link_analytes.roler_active"),
              intl.get("ciq.header_table_link_analytes.maximum_imprecision"),
              intl.get("ciq.header_table_link_analytes.status"),
              "",
            ]}
            handleClickSettings={fnHandleOpenAnalyteSettings}
            setEqpAnalytes={setEqpAnalytes}
            setTableBodyArray={setTableBodyArray}
            eqp_analytes={eqp_analytes}
            handleClickRemoveAnalyteLinked={fnHandleRemoveVinculatedAnalyte}
            tbodyArray={tableBodyArray}
            cursorNormal
            cTextNoData={intl.get("ciq.any_analyte_link")}
          />
        </FormEditEquipament>
      </ContentBlank>
      {bIsOpenModal && (
        <AnalytePicker
          listAnalytesHistory={listAnalytesHistory}
          setBisOpenModal={setBisOpenModal}
          setListAnalytesAddInEqp={setListAnalytesAddInEqp}
          listAnalytesAddInEqp={listAnalytesAddInEqp}
          infoInfititeScroll={infoInfititeScroll}
          fnNextPage={fnNextPage}
          isChecked={isChecked}
          fnHandleChange={fnHandleChange}
          fnSearchAnalyte={fnSearchAnalyte}
          removeDuplicated={removeDuplicated}
          everyPropertiesIsChecked={everyPropertiesIsChecked}
          fnHandleSelectAnalyte={fnHandleSelectAnalyte}
          isLoad={isLoad}
        />
      )}
      {bIsHistoryOpenModal && (
        <ModalComponent
          title={intl.get("ciq.equipment_history")}
          fnCloseModal={() => setBIsHistoryOpenModal(false)}
          size="xlg"
        >
          <HistoryComponent
            searchHistory="equipment"
            history={dataHistory}
            infoInfinitScroll={infoInfinitScroll}
            setPerPage={setPerPageHistory}
            perPage={per_pageHistory}
            isLoadHistory={isLoadHistory}
            setSearchType={setSearchType}
            setSearchText={setTextType}
          />
        </ModalComponent>
      )}
      {bIsOpenModalSettingsEquiment && (
        <ModalSettingsEquipment
          setIsChanged={setIsChanged}
          tableBodyArray={tableBodyArray}
          setTableBodyArray={setTableBodyArray}
          setbIsOpenModalSettingsEquiment={setbIsOpenModalSettingsEquiment}
          isTabEdit={isTabEdit}
          setIsTabEdit={setIsTabEdit}
          isSwitchSuspense={isSwitchSuspense}
          setIsSwitchSuspense={setIsSwitchSuspense}
          setIsCheckedSwitch={setIsCheckedSwitch}
        />
      )}
    </div>
  )
}
export default EditEquipaments
